import { render, staticRenderFns } from "./ChildSafetyPolicy.vue?vue&type=template&id=2c7b6864&scoped=true"
import script from "./ChildSafetyPolicy.vue?vue&type=script&lang=js"
export * from "./ChildSafetyPolicy.vue?vue&type=script&lang=js"
import style0 from "./ChildSafetyPolicy.vue?vue&type=style&index=0&id=2c7b6864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7b6864",
  null
  
)

export default component.exports